module.exports = __webpack_public_path__ + "img/output.5db0f3d7.png";